export const version = "1.7.17-daily-20260807-1";
export const channel = "daily";
export const gitcommit = "2f0102af8";
